// extracted by mini-css-extract-plugin
export default {"loginContainer":"ForgotPasswordPage_loginContainer__SY-85","login":"ForgotPasswordPage_login__kHQtl"};